
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import WidgetNavigationMap from '../../../moreCore/UI/Navigation/WidgetNavigationMap';
import TiTimeTableSlotsPicker from './TTSlotsPicker';
import { TiEntities } from "../TiTypes";



/**
 * Home-Navigation für Orchesterdienste-Bereich
 */


enum NavigationGroups{
    Timetable = "TiTimeTableSlotsPanel__Home" // gibt nur eine Ebene der Gruppierung...
}

interface ResponseData {
    tiles: Array<routeSectionTile>,
    divisions: Array<TiEntities.DivisionEntity>
}

interface routeSectionTile {
    routeSectionID: string
    label: string;
    icon: string;
    color: more.EntityAPIColor;
}
class TiTimeTableSlotsPanelNavigation extends compose(WidgetNavigationMap<any>) {

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        //this.layoutConfig["tiles"].tileWidth = "25ch";
        //this.layoutConfig["rows"].navigationAreaLayout = "tiles";
        this.layoutConfig["compact"].navigationAreaWidthBaseValue = "60%";
       
    }


    private _onSelect_Navigation(mapEntry: WidgetNavigation.mappingConfig) {
        let tile = mapEntry.keyValue as routeSectionTile;
        let sectionID = tile.routeSectionID;

        let tabName = "slotty-" + sectionID;
        //let panel: TiTimeTableSlotsPanel = null;

        let divisions = this._responseData.divisions;


        if (this.activateTab(tabName) != true) {

            //panel = new TiTimeTableSlotsPanel();

            let picker = new TiTimeTableSlotsPicker();

            this.requestNewTabbedContent({
                enableClosing: true,
                label: mapEntry.label,
                name: tabName,
                widget: picker
            }, true);

            picker.startup();

            picker.setup({ sectionID: sectionID, selectableDivisions: divisions, heading: tile.label });

        } else {
            let page = this.getExistingTab(tabName);

        //    panel = page.widget as TiTimeTableSlotsPanel;
        }

    //    if (panel) {
    //        // dem panel sagen es soll einen weiteren Resourepicker für die gewählte Teilstrecke 
    //    }
    }

    private _loadNavigationTiles() {

        let data = {
            // noch nix mitzugeben...
        };

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TiTimeTableSlotsPanel__LoadSectionRouteNavigation",
            data,
            lang.hitch(this, this._onLoadNavigationTilesResponse),
            lang.hitch(this, this._onLoadNavigationTilesError)
        );
    }

    private _responseData: ResponseData;

    private _onLoadNavigationTilesError(error: more.requestErrorMessage) {
        setTimeout(lang.hitch(this, this._loadNavigationTiles), 1500);
        
    }
    private _onLoadNavigationTilesResponse(response: ResponseData) {

        let newRecord: Record<string, WidgetNavigation.mappingConfig> = {};
        let settings: Record<string, WidgetNavigation.navigationAreaSettings> = {};

        this._responseData = response;
        
        for (let tile of response.tiles) {
            newRecord[tile.routeSectionID] = {
                label: tile.label,
                navigationAreaName: "Ti_Label_RouteSections",
                icon: tile.icon,
                color: tile.color,
                keyValue: tile,
                callback: lang.hitch(this, this._onSelect_Navigation),
            };
        }

        this.StandbyStop();

        this.setup(newRecord, settings);
    }


    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles("TiTimeTableSlotsPanel__Navigation");

        this._loadNavigationTiles();
    }
}

export default mdsWidget(TiTimeTableSlotsPanelNavigation);